import { Controller } from '@hotwired/stimulus';
import Chart from 'chart.js/auto';

export default class extends Controller {
  static values = {
    chartData: Object,
    type: { type: String, default: 'pie' },
  }

  static targets = ['canvas']
  chart = null

  connect() {

    if (Chart.getChart(this.canvasTarget)) {
      Chart.getChart(this.canvasTarget).destroy();
    }

    switch (this.typeValue) {
      case 'pie':
        this.pieChart();
        break;
      case 'bars':
        this.barsChart();
        break;
      case 'line':
        this.linesChart();
        break;
      case 'doughnut':
        this.doughnutChart();
        break;
    }
  }

  disconnect() {
    if (Chart.getChart(this.canvasTarget)) {
      Chart.getChart(this.canvasTarget).destroy();
    }
  }


  linesChart() {
    const data = this.chartDataValue;

    new Chart(this.canvasTarget, {
      type: 'line',
      data: data,
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              maxTicksLimit: 5
            }
          }
        },
      }
    });
  }

  barsChart() {
    const data = this.chartDataValue;

    new Chart(this.canvasTarget, {
      type: 'bar',
      data: data,
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            barPercentage: 0.7,      
            categoryPercentage: 0.8
          },
          y: {
            grid: {
              display: false
            },
            beginAtZero: true,
            ticks: {
              maxTicksLimit: 5
            }
          }
        }
      }
    });
  }

  pieChart() {
    const data = this.chartDataValue;

    new Chart(this.canvasTarget, {
      type: 'pie',
      data: data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 2,
        plugins: {
          legend: {
            position: 'right',
            align: 'start',
            onClick: null,
            labels: {
              padding: 4,
              boxWidth: 12,
              font: {
                size: 12 
              },
            }
          }
        }
      }
    });
  }

  doughnutChart() {
    const data = this.chartDataValue;

    new Chart(this.canvasTarget, {
      type: 'doughnut',
      data: data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 2,
        cutout: '50%', 
        plugins: {
          legend: {
            position: 'right',
            align: 'start',
            onClick: null,
            labels: {
              padding: 4,
              boxWidth: 12,
              font: {
                size: 12 
              },
            }
          }
        }
      }
    });
  }

  
}
